var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M732.1 399.3C534.6 356 696.5 82.1 425.9 104.8s-527.2 645.8-46.8 791.7 728-415 353-497.2z",
    fill: "#464BD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.8 449.8c0 37 30 66.9 66.9 66.9h319c9.6 0 17.4 7.8 17.4 17.4v234.7c0 9.6-7.8 17.4-17.4 17.4H389.3c-62.2 0-112.5-50.4-112.5-112.5V442.3",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M662.8 795.5H389.3c-67.2 0-121.8-54.6-121.8-121.8V442.3c0-5.1 4.1-9.3 9.3-9.3s9.3 4.1 9.3 9.3v7.6c0 31.8 25.9 57.7 57.7 57.7h319c14.7 0 26.6 12 26.6 26.6v234.7c0 14.6-11.9 26.6-26.6 26.6zM286.1 499.6v174.1c0 57 46.3 103.3 103.3 103.3h273.4c4.5 0 8.1-3.6 8.1-8.1V534.2c0-4.5-3.6-8.1-8.1-8.1h-319a76.2 76.2 0 0 1-57.7-26.5z",
    fill: "#151B28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M662.8 795.5H389.3c-67.2 0-121.8-54.6-121.8-121.8V447.1c0-40.6 33.1-73.7 73.7-73.7h319.7c5.1 0 9.3 4.1 9.3 9.3s-4.1 9.3-9.3 9.3H341.2c-30.4 0-55.2 24.8-55.2 55.2v2.7c0 31.8 25.9 57.7 57.7 57.7h319c14.7 0 26.6 12 26.6 26.6v234.7a26.5 26.5 0 0 1-26.5 26.6zM286.1 499.6v174.1c0 57 46.3 103.3 103.3 103.3h273.4c4.5 0 8.1-3.6 8.1-8.1V534.2c0-4.5-3.6-8.1-8.1-8.1h-319a76.2 76.2 0 0 1-57.7-26.5z",
    fill: "#151B28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M589.3 517H384.7V320.3c0-10.2 8.3-18.4 18.4-18.4h167.7c10.2 0 18.4 8.3 18.4 18.4V517z",
    fill: "#2AEFC8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M589.3 525.5H384.7a8.5 8.5 0 0 1-8.5-8.5V320.3c0-14.8 12.1-26.9 26.9-26.9h167.7c14.8 0 26.9 12.1 26.9 26.9V517c0.1 4.7-3.7 8.5-8.4 8.5z m-196.1-17h187.7V320.3c0-5.5-4.5-10-10-10H403.1c-5.5 0-10 4.5-10 10v188.2z",
    fill: "#151B28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M422.2 307.7h44.9V511h-44.9z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M467.1 515.7h-44.9a4.8 4.8 0 0 1-4.8-4.8V307.7c0-2.6 2.1-4.8 4.8-4.8h44.9c2.6 0 4.8 2.1 4.8 4.8V511c0 2.6-2.2 4.7-4.8 4.7z m-40.1-9.5h35.4V312.4H427v193.8z m74.6-178h15.5v42.5h-15.5zM501.6 386.1h15.5v104.5h-15.5zM542.2 328.2h15.5v162.4h-15.5z",
    fill: "#151B28"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M694.1 588.8H521.5c-25.7 0-48.6 18.8-51 44.3-2.8 29.3 20.2 54 48.9 54h174.7c5.8 0 10.4-4.7 10.4-10.4v-77.5c0-5.7-4.6-10.4-10.4-10.4z",
    fill: "#464BD8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M694.1 696.1H519.4c-16.3 0-32-6.9-43-19a58.23 58.23 0 0 1-14.8-44.8c2.8-29.4 29.1-52.4 60-52.4h172.6c10.7 0 19.4 8.7 19.4 19.4v77.5c-0.1 10.6-8.8 19.3-19.5 19.3z m-172.6-98.3c-21.7 0-40.2 15.9-42.1 36.2a39.63 39.63 0 0 0 10.3 31 40.3 40.3 0 0 0 29.8 13.2h174.7c0.8 0 1.5-0.7 1.5-1.5v-77.5c0-0.8-0.7-1.5-1.5-1.5l-172.7 0.1z",
    fill: "#151B28"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M523.3 638m-22.8 0a22.8 22.8 0 1 0 45.6 0 22.8 22.8 0 1 0-45.6 0Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.fe17141ee8d00b484f4a21884cb53101.svg";
export { ForwardRef as ReactComponent };